import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../Config/Base';
import { ToastContainer, toast } from 'react-toastify';
import { Oval } from  'react-loader-spinner'

const Tecsectionmain = () => {


  const token = JSON.parse(localStorage.getItem('usertoken'));



   useEffect(()=>{
     document.getElementById('tec-sectionMain').style.display = "none";
     document.getElementById('tecLableSection').style.display = "none";
     setpop(true);
     getUser();
    SelectParticular();
   
     setTimeout(()=>{
      setpop(false);
      getresult();
     
     },1000)
    
     setTimeout(()=>{
      setpop(false);
      
      document.getElementById('tec-sectionMain').style.display = "block";

    },2000)
   },[])

   const[pop,setpop] = useState(false);
  function getUser(){


    console.log("Token", token)
  fetch(`${BASE_URL}/Tec/Gettecusers`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " + `${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("Data", data)
      localStorage.setItem("Data", JSON.stringify(data));
        }
    );


  }

 var UserId= localStorage.getItem('UserId')
  function SelectParticular(){
    const body =
    {
      
     id:UserId
    }
    console.log('body',body);

  
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/Getparticularid`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + `${token}`,
            }     
        }) 
        
   
        .then((response) =>{
          console.log(response.data);
     
       
          localStorage.setItem("SectionData", JSON.stringify(response.data));
          
       })
       .catch(error => {
         console.log(error);
         
       })

   }
  
  function getresult(){
   
      ////Admin
    let LoginRole =  localStorage.getItem("RoleId");
    let CheckAdmin =LoginRole.includes("01")

    let alldata = localStorage.getItem("Data");
    //console.log(alldata)
    
    
    let namedata =  JSON.parse(alldata);
     //console.log(namedata)
    
    let names = namedata&&namedata.map((item) => item.userName);
       //console.log("username",names)
    
       let UserName= names.toString();
       //console.log(UserName)

    
    let loginUser =localStorage.getItem('username')
    //console.log(loginUser)
    
    let Nameresult = UserName.includes(loginUser);  
    //console.log(Nameresult)
    
    
    /*---get section data ---*/
    
    
    let Usersectiondata =  localStorage.getItem("SectionData");
    //console.log(Usersectiondata)
    
    
    let data =  JSON.parse(Usersectiondata);
     //console.log(data)
    
    let sections = data&&data.map((item) => item.section);
       //console.log(sections)
    
       let sectionstr = sections.toString();
       console.log(sectionstr);
 
       let sectionresult =sectionstr.includes('Index')
       //console.log(sectionresult)
       let sectionresultA =sectionstr.includes('Company')
       //console.log(sectionresultA)
       let sectionresultB =sectionstr.includes('Expertise')
       //console.log(sectionresultB)
       let sectionresultC =sectionstr.includes('Technologies')
       //console.log(sectionresultC)
       let sectionresultD =sectionstr.includes('Products')
       //console.log(sectionresultD)
       let sectionresultE =sectionstr.includes('Talk to Us')
       //console.log(sectionresultE)
       let sectionresultF =sectionstr.includes('')
       //console.log(sectionresultF)
       //let sectionresultF =sectionstr.includes('')
       
       document.getElementById('tecLableSection').style.display = "block";
  //  if(Nameresult==true && sectionresultF==true){
   
    
  //   document.getElementById('tecLableSection').style.display = "block";
  //  }
  //  else{
       
  //   document.getElementById('tecLableSection').style.display = "block";
  //   }
  
    if(Nameresult==true && sectionresult==true){
   
      document.getElementById('tec-lableMainA').style.animation = "tecpickup1 1.5s 1 forwards";     

      document.getElementById('tec-lableMainA').style.display = "flex"; 
      document.getElementById('tec-lableMainA').style.position="absolute" 
      
     setTimeout(()=>{
      document.getElementById('tec-lableMainA').style.position="static" 
      document.getElementById('tec-touchMainA').style.display = "flex"; 
    },1000)
    }
  else{
       document.getElementById('tec-touchMainA').style.display = "none"; 
       document.getElementById('tec-lableMainA').style.animation = "tecpickup 1.5s 1 forwards";
       document.getElementById('tec-lableMainA').style.display = "none";
    }
    
    if(Nameresult==true && sectionresultA==true){
     
      
      document.getElementById('tec-lableMainB').style.animation = "tecpickup2 1.5s 1 forwards";
      document.getElementById('tec-lableMainB').style.display = "flex"; 
      document.getElementById('tec-lableMainB').style.position="absolute"
      setTimeout(()=>{
        document.getElementById('tec-lableMainB').style.position="static"
        document.getElementById('tec-touchMainB').style.display = "flex";
      },1000)
    }
    else{
      document.getElementById('tec-touchMainB').style.display = "none"; 
      document.getElementById('tec-lableMainB').style.animation = "tecpickup 1.5s 1 forwards";
      document.getElementById('tec-lableMainB').style.display = "none";
    }
  
    if(Nameresult==true && sectionresultB==true){
     
      
      document.getElementById('tec-lableMainC').style.animation = "tecpickup3 1.5s 1 forwards";
      document.getElementById('tec-lableMainC').style.display = "flex"; 
      document.getElementById('tec-lableMainC').style.position="absolute" 
      setTimeout(()=>{
        document.getElementById('tec-lableMainC').style.position="static" 
        document.getElementById('tec-touchMainC').style.display = "flex";
      },1000)
    }
    else{
      document.getElementById('tec-touchMainC').style.display = "none"; 
      document.getElementById('tec-lableMainC').style.animation = "tecpickup 1.5s 1 forwards";
      document.getElementById('tec-lableMainC').style.display = "none";
   
    }
    if(Nameresult==true && sectionresultC==true){
     
      
      document.getElementById('tec-lableMainD').style.animation = "tecpickup4 1.5s 1 forwards";
      document.getElementById('tec-lableMainD').style.display = "flex";
      document.getElementById('tec-lableMainD').style.position="absolute" 
      setTimeout(()=>{
        document.getElementById('tec-lableMainD').style.position="static" 
        document.getElementById('tec-touchMainD').style.display = "flex";
      },1000)
    }
    else{
      
      document.getElementById('tec-touchMainD').style.display = "none"; 
      document.getElementById('tec-lableMainD').style.animation = "tecpickup 1.5s 1 forwards";
      document.getElementById('tec-lableMainD').style.display = "none";
    }

    if(Nameresult==true && sectionresultD==true){
     
     
      document.getElementById('tec-lableMainE').style.animation = "tecpickup5 1.5s 1 forwards";
      document.getElementById('tec-lableMainE').style.display = "flex";
      document.getElementById('tec-lableMainE').style.position="absolute"   
      setTimeout(()=>{
        document.getElementById('tec-lableMainE').style.position="static" 
        document.getElementById('tec-touchMainE').style.display = "flex";
      },1000)
    }
    else{
      document.getElementById('tec-touchMainE').style.display = "none"; 
      document.getElementById('tec-lableMainE').style.animation = "tecpickup 1.5s 1 forwards";
      document.getElementById('tec-lableMainE').style.display = "none";
    }
    if(Nameresult==true && sectionresultE==true){
     
     
      document.getElementById('tec-lableMainF').style.animation = "tecpickup6 1.5s 1 forwards";
      document.getElementById('tec-lableMainF').style.display = "flex";
      document.getElementById('tec-lableMainF').style.position="absolute"   
      setTimeout(()=>{
        document.getElementById('tec-lableMainF').style.position="static"   
        document.getElementById('tec-touchMainF').style.display = "flex";
      },1000)
    }
    else{
      document.getElementById('tec-touchMainF').style.display = "none"; 
      document.getElementById('tec-lableMainF').style.animation = "tecpickup 1.5s 1 forwards";
      document.getElementById('tec-lableMainF').style.display = "none";
    }
 
 
    if(Nameresult==true && sectionresult==false  && sectionresultA==false && sectionresultB==false && sectionresultC==false && sectionresultD==false && sectionresultE==false){
 

     
      document.getElementById('tec-sectionMain').innerHTML = "Sections Not yet Assigned!";
      document.getElementById('tec-sectionMain').style.color="red"
      document.getElementById('tec-sectionMain').style.left="40%"
    }

    if(CheckAdmin==true){
      document.getElementById('tec-lableMainA').style.animation = "tecpickup1 1.5s 1 forwards";     

      document.getElementById('tec-lableMainA').style.display = "flex"; 
      document.getElementById('tec-lableMainA').style.position="absolute" 
      document.getElementById('tec-lableMainB').style.animation = "tecpickup2 1.5s 1 forwards";
      document.getElementById('tec-lableMainB').style.display = "flex"; 
      document.getElementById('tec-lableMainB').style.position="absolute"
      document.getElementById('tec-lableMainC').style.animation = "tecpickup3 1.5s 1 forwards";
      document.getElementById('tec-lableMainC').style.display = "flex"; 
      document.getElementById('tec-lableMainC').style.position="absolute" 
      document.getElementById('tec-lableMainD').style.animation = "tecpickup4 1.5s 1 forwards";
      document.getElementById('tec-lableMainD').style.display = "flex";
      document.getElementById('tec-lableMainD').style.position="absolute" 
      document.getElementById('tec-lableMainE').style.animation = "tecpickup5 1.5s 1 forwards";
      document.getElementById('tec-lableMainE').style.display = "flex";
      document.getElementById('tec-lableMainE').style.position="absolute"   
      document.getElementById('tec-lableMainF').style.animation = "tecpickup6 1.5s 1 forwards";
      document.getElementById('tec-lableMainF').style.display = "flex";
      document.getElementById('tec-lableMainF').style.position="absolute"   
    
    
    
      setTimeout(()=>{
        document.getElementById('tec-lableMainA').style.position="static" 
        document.getElementById('tec-touchMainA').style.display = "flex"; 
        document.getElementById('tec-lableMainB').style.position="static"
        document.getElementById('tec-touchMainB').style.display = "flex";
        document.getElementById('tec-lableMainC').style.position="static" 
        document.getElementById('tec-touchMainC').style.display = "flex";
        document.getElementById('tec-lableMainD').style.position="static" 
        document.getElementById('tec-touchMainD').style.display = "flex";
        document.getElementById('tec-lableMainE').style.position="static" 
        document.getElementById('tec-touchMainE').style.display = "flex";
        document.getElementById('tec-lableMainF').style.position="static"   
        document.getElementById('tec-touchMainF').style.display = "flex";
      },1000)
    
    
    
    
    
    }
  }
 
  


   

   
  return (
    <div className='tec-addmain'>
      
      
    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
         <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">SECTION</span> </span>
 <div className='tec-addmain-back'>
  <Link to="/Kdp Tec"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div></p> 

 {/* <hr></hr> */}
 </div>
    </div>    


    <ul id="tecLableSection">
  <li className="tecdot tecdotty1"id="tec-lableMainA"></li>
  <li className="tecdot tecdotty2" id="tec-lableMainB"></li>
  <li className="tecdot tecdotty3" id="tec-lableMainC"></li>
  <li className="tecdot tecdotty4" id="tec-lableMainD"></li>
  <li className="tecdot tecdotty5" id="tec-lableMainE"></li>
  <li className="tecdot tecdotty6" id="tec-lableMainF"></li>
  </ul>
  <ul id='tec-sectionMain'>

<li className='tectitle1 tectitle-animate' id="tec-touchMainA"><Link to="/TecIndex">Index</Link></li>
<li className='tectitle2 tectitle-animate'  id="tec-touchMainB"><Link to="/TecCompany">Company</Link></li>
<li className='tectitle3 tectitle-animate'  id="tec-touchMainC"><Link to="/TecSExpertise">Expertise</Link></li>
<li className='tectitle4 tectitle-animate'  id="tec-touchMainD"><Link to="/TecSTechnology">Technologies</Link></li>
<li className='tectitle5 tectitle-animate'  id="tec-touchMainE"><Link to="/TecSProduct">Products</Link></li>
<li className='tectitle6S tectitle-animate'  id="tec-touchMainF"><Link to="/TecTalk">Talk to Us</Link></li>


 </ul>
   
     <div>
    
    <ul id='tec-sectionMain'>
    
    
    
     {/* <li id="tec-touchMainA">
          
        <nav id="tec-section-nav">
    
    <label for="tec-touchA" id="tecsectionlable"  >
    
      <i class="fa fa-folder"   aria-hidden="true" id="PlusA-icon-tec" onClick={opensectionA}></i>
      <i class="fa fa-folder-open"   aria-hidden="true" id="minusA-icon-tec" onClick={closesectionA}></i>
      &nbsp;<span id ="tec-sectionA-head"> Index</span>
      </label>               
    <input type="checkbox" id="tec-touchA" /> 
    
    <ul class="tec-slide" id="tec-slideA">

    
    <ul className='TecSectionList' >
    <li><Link to="/TecFirst">First</Link></li> 
    <li><Link to="/TecExpertise"> Expertise</Link></li> 
    <li><Link to="/TecLeaders"> Leaders</Link></li> 
    <li><Link to="/TecProduct">Our Products</Link></li> 
    <li><Link to="/TecFooter">Footer</Link></li>
   
    </ul>

   
    </ul>
    
    </nav> 
    </li> */}
    {/* <li id="tec-touchMainB">
        <nav id="tec-section-nav">
    
    <label for="tec-touchB" id="tecsectionlable" >
    
      <i class="fa fa-folder"   aria-hidden="true" id="PlusB-icon-tec" onClick={opensectionB}></i>
      <i class="fa fa-folder-open"   aria-hidden="true" id="minusB-icon-tec" onClick={closesectionB}></i>
      &nbsp;<span id ="tec-sectionB-head"> Company</span>
      </label>               
    <input type="checkbox" id="tec-touchB" /> 
    
    <ul class="tec-slide" id="tec-slideB">
    <ul className='TecSectionList'>
 
    <li><Link to="/TecAbout">About</Link></li> 
    <li><Link to="/TecLeaders">Team</Link></li> 
    <li><Link to="/TecLife">Life here</Link></li> 
    <li><Link to="/TecGiving">Giving back</Link></li>
    <li><Link to="/TecCareers">Careers</Link></li>  
    </ul>
    </ul>
    
    </nav> 
    </li> */}
    {/* <li id="tec-touchMainC">
        <nav id="tec-section-nav">
    
    <label for="tec-touchC" id="tecsectionlable">
    
      <i class="fa fa-folder"   aria-hidden="true" id="PlusC-icon-tec" onClick={opensectionC}></i>
      <i class="fa fa-folder-open"   aria-hidden="true" id="minusC-icon-tec" onClick={closesectionC}></i>
      &nbsp;<span id ="tec-sectionC-head">Expertise</span>
      </label>               
    <input type="checkbox" id="tec-touchC" /> 
    
    <ul class="tec-slide" id="tec-slideC">
    <ul className='TecSectionList'>
    
    <li><Link to="/TecMobile">  Mobile Application Development</Link></li>

    <li><Link to="/TecWeb">  Web Application and Website Development</Link></li> 

    <li><Link to="/TecCloud">  Cloud Computing</Link></li>
 
    <li><Link to="/TecData">  Data Migration</Link></li>

    <li><Link to="/TecBusiness"> Business Intelligence & Analytics</Link></li>

    <li><Link to="/TecDigital"> Digital Marketing</Link></li>
 
    <li><Link to="/TecServices"> Application Services and Modernization</Link></li> 

    <li><Link to="/TecITES">  ITES</Link></li> 
  
    <li><Link to="/TecStaff">  Staff Augmentation</Link></li>   
    </ul>
    </ul>
    
    </nav> 
    </li> */}
    {/* <li  id="tec-touchMainD">
      <nav id="tec-section-nav">
    
    <label for="tec-touchD"  id="tecsectionlable">
    
      <i class="fa fa-folder"   aria-hidden="true" id="PlusD-icon-tec" onClick={opensectionD}></i>
      <i class="fa fa-folder-open"   aria-hidden="true" id="minusD-icon-tec" onClick={closesectionD}></i>
      &nbsp;<span id ="tec-sectionD-head">Technologies</span>
      </label>               
    <input type="checkbox" id="tec-touchD" /> 
    
    <ul class="tec-slide" id="tec-slideD">
    <ul className='TecSectionList'>
 
    <li><Link to="/TecTechnology"> Technology</Link></li> 
  
    </ul>
    </ul>
    
    </nav>
    </li> */}
    {/* <li id="tec-touchMainE">
    <nav id="tec-section-nav">
    
    <label for="tec-touchE" id="tecsectionlable"  >
    
      <i class="fa fa-folder"   aria-hidden="true" id="PlusE-icon-tec" onClick={opensectionE}></i>
      <i class="fa fa-folder-open"   aria-hidden="true" id="minusE-icon-tec" onClick={closesectionE}></i>
      &nbsp;<span id ="tec-sectionE-head">Products</span>
      </label>               
    <input type="checkbox" id="tec-touchE" /> 
    
    <ul class="tec-slide" id="tec-slideE">
    <ul className='TecSectionList'>
    <li><Link to="/TecProduct"> Product</Link></li> 
    
  
    </ul>
    </ul>
    
    </nav>
    </li> */}
    {/* <li  id="tec-touchMainF">
    <nav id="tec-section-nav">
    
    <label for="tec-touchF" id="tecsectionlable" >
    
      <i class="fa fa-folder"   aria-hidden="true" id="PlusF-icon-tec" onClick={opensectionF}></i>
      <i class="fa fa-folder-open"   aria-hidden="true" id="minusF-icon-tec" onClick={closesectionF}></i>
      &nbsp;<span id ="tec-sectionF-head">Talk to Us</span>
      </label>               
    <input type="checkbox" id="tec-touchF" /> 
    
    <ul class="tec-slide" id="tec-slideF">
    <ul className='TecSectionList'>
   
    <li><Link to="/TecAddress"> Address</Link></li> 

    </ul>
    </ul>
    
    </nav>
    </li>
     */}
    </ul>
        </div>
  
        {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}

        </div>
  )
}

export default Tecsectionmain
